import * as React from 'react';
import { observer } from 'mobx-react';
import useStore from '@src/utils/hooks/use-store';
import MainStore from '@src/pages/main/store';
import Page from '../../components/page';
import PageSwiper from '../../components/swiper/page-swiper';
import FirstSection from './sections/first-section';
import NegativeSection from './sections/negative-section';
import SecondSection from './sections/second-section';
// import CreatorsSection from './sections/creators-section';
import NaviBar from '@src/business-components/navibar';
import ThirdSection from './sections/third-section';
import FourSection from './sections/four-section';
import FiveSection from './sections/five-section';
import SixSection from './sections/six-section';
import SevenSection from './sections/seven-section';
import ComponentFooter from '@src/business-components/common-footer';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
const lang = getLanguageByPath();
import cx from 'classnames';

const styles = require('./index.less');

const Main = () => {
  /**
   * store
   * @type {MainStore}
   */
  const store = useStore(() => new MainStore());

  const slides = [
    {
      name: '30年倒计时 延迟加载',
      component: NegativeSection,
      store: store.negativeSectionStore,
      showSlide: false,
      isRender: store.negativeLoadstate && !store.isFirstLoadNegativeSection
    },
    {
      name: 'kv-首屏',
      component: FirstSection,
      store: store.firstSectionStore,
      showSlide: true,
      isRender: true
    },
    {
      name: '第二屏-赛事',
      component: SecondSection,
      store: store.secondSectionStore,
      showSlide: store.isOpenCompetition,
      isRender: store.secondLoadState
    },
    {
      name: '第三屏-版本亮点',
      component: ThirdSection,
      store: store.thirdSectionStore,
      showSlide: true,
      isRender: store.fourLoadState
    },
    {
      name: '第四屏-大地图以及据点展示',
      component: FourSection,
      store: store.fourSectionStore,
      showSlide: true,
      isRender: store.fiveLoadState
    },
    {
      name: '第五屏-空投装备展示',
      component: FiveSection,
      store: store.fiveSectionStore,
      showSlide: true,
      isRender: store.sixLoadState
    },
    {
      name: '第六屏-载具武装-踏板',
      component: SixSection,
      store: store.sixSectionStore,
      showSlide: true,
      isRender: store.sevenLoadState
    },
    {
      name: '第七屏-阵营&杂兵',
      component: SevenSection,
      store: store.sevenSectionStore,
      showSlide: true,
      isRender: true
    }
  ];

  return (
    <Page className={cx(styles.root, 'page-main')}>
      {/* {store.isShowTopBar && <TopBar store={store.topBarStore} />} */}
      <NaviBar store={store.naviBarStore} />

      <div className={'page-swiper'}>
        <PageSwiper key={store.isOpenCompetition} store={store.pageSwiper}>
          {/* <div className={styles.pageItem} data-name="预热页面">
            {store.negativeLoadstate && <NegativeSection store={store.negativeSectionStore} />}
          </div>
          <div className={styles.pageItem} data-name="kv">
            <FirstSection store={store.firstSectionStore} />
          </div>
          <div className={styles.pageItem} data-name="第二屏-赛事">
            {(store.secondLoadState || store.pageSwiper.activeIndex === 2) && <SecondSection store={store.secondSectionStore} />}
          </div>
          <div className={styles.pageItem} data-name="第四屏-版本亮点">
            {(store.fourLoadState || store.pageSwiper.activeIndex === 3) && <ThirdSection store={store.thirdSectionStore} />}
          </div>
          <div className={styles.pageItem} data-name="第五屏-地图">
            {(store.fiveLoadState || store.pageSwiper.activeIndex === 4) && <FourSection store={store.fourSectionStore} />}
          </div>
          <div className={styles.pageItem} data-name="第六屏-空投装备">
            {(store.sixLoadState || store.pageSwiper.activeIndex === 5) && <FiveSection store={store.fiveSectionStore} />}
          </div>
          <div className={styles.pageItem} data-name="第七屏-载具武装-踏板">
            {(store.sevenLoadState || store.pageSwiper.activeIndex === 6) && <SixSection store={store.sixSectionStore} />}
          </div>
          <div className={styles.pageItem} data-name="第八屏-机兵">
            {(store.eightLoadState || store.pageSwiper.activeIndex === 7) && <SevenSection store={store.sevenSectionStore} />}
          </div> */}
          {slides.filter(item => item.showSlide).map((item, index) => (
            <div key={index} className={styles.pageItem} data-name={item.name}>
              {(item.isRender || store.pageSwiper.activeIndex === index) && React.createElement(item.component, { store: item.store })}
            </div>
          ))}
        </PageSwiper>
        {/* <ComponentFooter store={store.comFooterStore} /> */}
        <div className={cx(styles.omniCommonFooterRoot, store.pageSwiper.baseSwiperStore.activeIndex > 5 && styles.footerShow)}>
          <div id="OMNI__COMMON__FOOTER" className="OMNI__COMMON__FOOTER" />
        </div>
      </div>
      {/* <FooterSection store={store.footerSection} /> */}
    </Page>
  );
};

export default observer(Main);
